import { startsWith } from 'lodash/fp';
import { useReducer } from 'react';
import { createTrueValuesObject, mapValuesIndexed } from '@mews-commander/utils';

const expandedReducer = (expanded: $TSFixMe, currentNestedIndex: $TSFixMe) =>
    !expanded[currentNestedIndex]
        ? { ...expanded, [currentNestedIndex]: true }
        : mapValuesIndexed(
              (value: $TSFixMe, key: $TSFixMe) => (startsWith(currentNestedIndex, key) ? false : value),
              expanded
          );

export const useExpanded = (preExpandedIndexes: $TSFixMe) =>
    useReducer(expandedReducer, createTrueValuesObject(preExpandedIndexes));
